import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';
// @ts-ignore
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { Auth } from 'src/app/core/models/auth.model';
import { User } from 'src/app/modules/cart-items/model/cart-items';
import { environment } from 'src/environments/environment.dev';
import { AuthStoreService } from 'src/app/core/services/auth-store.service';
import { CryptoService } from 'src/app/core/services/crypto.service';

export interface LoginResponse {
  success: boolean;
  message: string;
  token: string;
  usuario: {
    id: string;
    username: string | null;
    first_name: string;
    last_name: string | null;
    email: string;
    avatar_url: string | null;
    created_at: string;
    updated_at: string;
    roles: string[];
  };
  roles: string[];
}

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private readonly API_URL = environment.apiUrl;
  env = environment;
  symmetricKey = this.env.symmetricKey;
  headers: HttpHeaders;

  constructor(
    private http: HttpClient,
    private router: Router,
    private authStore: AuthStoreService,
    private cryptoService: CryptoService
  ) {
    this.headers = new HttpHeaders({ Accept: 'application/json' });
  }

  login(email: string, password: string): Observable<LoginResponse> {
    const encryptedBody = { payload: this.cryptoService.encryptPayload({ email, password }) };
    return this.http.post<any>(`${this.API_URL}/auth/login`, encryptedBody).pipe(
      map((res: any) => {
        if (res && res.encrypted && res.payload) {
          return this.cryptoService.decryptPayload(res.payload);
        }
        return res;
      })
    );
  }

  isAuthenticated() {
    return !!localStorage.getItem('token');
  }

  logOut(): Observable<any> {
    return this.http.get(`${this.API_URL}/logout`).pipe(
      tap(() => {
        this.authStore.clearAuth();
        localStorage.removeItem('sessionID');
        localStorage.removeItem('userData');
        this.router.navigate(['/auth/sign-in']);
      }),
      catchError((error) => {
        this.authStore.clearAuth();
        localStorage.removeItem('sessionID');
        localStorage.removeItem('userData');
        this.router.navigate(['/auth/sign-in']);
        throw error;
      }),
    );
  }

  userLoginGoogle(token: string): Observable<LoginResponse> {
    const encryptedBody = { payload: this.cryptoService.encryptPayload({ token }) };
    return this.http.post<any>(`${this.API_URL}/google`, encryptedBody).pipe(
      map((res: any) => {
        if (res && res.encrypted && res.payload) {
          return this.cryptoService.decryptPayload(res.payload);
        }
        return res;
      })
    );
  }

  handleCredentialResponse(response: any) {
    const googleToken = response.credential;
    const encryptedBody = { payload: this.cryptoService.encryptPayload({ token: googleToken }) };

    this.http.post<any>(this.API_URL + '/google', encryptedBody)
      .subscribe({
        next: (res) => { console.log('Login OK', res); },
        error: (err) => { console.error('Error', err); }
      });
  }

  register(body: any): Observable<LoginResponse> {
    const encryptedBody = { payload: this.cryptoService.encryptPayload(body) };
    return this.http.post<any>(`${this.API_URL}/auth/register`, encryptedBody).pipe(
      map((res: any) => {
        if (res && res.encrypted && res.payload) {
          return this.cryptoService.decryptPayload(res.payload);
        }
        return res;
      })
    );
  }
}
